import { useEffect, useRef } from "react";
import { ChevronDown } from "lucide-react";
import { REASONS } from "./WithdrawFields";

export const DONE_FILTERS = [["all", "All"], ["sold", "Sold"], ["passed", "Passed"], ["withdrawn", "Withdrawn"]];
const REASON_LABEL = { health: "Health / Veterinary Concern" };

// Pipeline tab a card belongs to (UI only): withdrawn horses live under Done; closed-but-unfinalized stay in Ongoing.
export const tabOf = (c) => (c.stage === "withdrawn" ? "completed" : c.stage);
const cat = (c) => (c.stage === "withdrawn" ? "withdrawn"
  : c.sale_record?.outcome === "sold" ? "sold" : c.sale_record?.outcome === "unsold" ? "passed" : null);
export const matchDone = (c, f, r) => f === "all" || (cat(c) === f && (f !== "withdrawn" || !r || c.sale_record?.withdrawal?.reason === r));

const Pill = ({ on, testId, onClick, children, n, sub }) => (
  <button type="button" data-testid={testId} aria-pressed={on} onClick={onClick}
    className={`shrink-0 h-9 px-3.5 rounded-full border text-sm inline-flex items-center gap-1.5 transition-colors ${on ? "bg-stone-800 border-stone-800 text-white font-semibold" : sub ? "bg-stone-50 border-stone-300 text-stone-700 hover:bg-white" : "bg-white border-stone-300 text-stone-700 hover:bg-stone-50"}`}>
    {children}<span data-testid={`${testId}-count`} className={`min-w-[20px] h-5 px-1.5 rounded-full text-[11px] font-bold flex items-center justify-center ${on ? "bg-white text-stone-900" : "bg-stone-200 text-stone-700"}`}>{n}</span>
  </button>
);

export function DoneFilter({ cards, f, r, set }) {
  const n = (k, rr) => cards.filter((c) => matchDone(c, k, rr)).length;
  const box = useRef(null);
  useEffect(() => {
    const el = box.current?.querySelectorAll('[aria-pressed="true"]');
    const last = el?.[el.length - 1];
    if (last && box.current) box.current.scrollLeft = Math.max(0, last.offsetLeft - 16);
  }, [f, r]);
  return (
    <div ref={box} data-testid="done-filter" role="group" aria-label="Done filter" className="relative flex gap-2 overflow-x-auto hide-scrollbar py-1 lg:flex-wrap">
      {DONE_FILTERS.map(([k, l]) => (
        <span key={k} className="contents">
          <Pill testId={`done-filter-${k}`} on={f === k && !(k === "withdrawn" && r)} n={n(k)} onClick={() => set(k, null)}>
            {l}{k === "withdrawn" && <ChevronDown className={`h-3.5 w-3.5 transition-transform ${f === "withdrawn" ? "rotate-180" : ""}`} />}
          </Pill>
          {k === "withdrawn" && f === "withdrawn" && (
            <span data-testid="done-filter-reasons" className="contents">
              {REASONS.map(([rk, rl]) => (
                <Pill key={rk} sub testId={`done-filter-reason-${rk}`} on={r === rk} n={n("withdrawn", rk)} onClick={() => set("withdrawn", rk)}>{REASON_LABEL[rk] || rl}</Pill>
              ))}
            </span>
          )}
        </span>
      ))}
    </div>
  );
}
